var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "actions-checkbox" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 pl-0 d-flex align-items-center apply-block" },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm.target.canvas
            ? _c("SelectTemplateDropdown", {
                attrs: {
                  "current-instance-id": _vm.target.canvas.instance_id,
                  "local-storage-key":
                    _vm.LOCAL_STORAGE_KEY_SELECTED_TEMPLATES_FOR_TEXT,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("SelectPropertiesDropdown", {
            attrs: {
              "is-color-selector": !!_vm.options.colorSelector,
              "is-font-selector": !!_vm.options.fontSelector,
              "is-alignment-selector": !!_vm.options.alignmentSelector,
              "is-banner-builder": _vm.isBannerBuilder,
            },
            on: { change: _vm.onChange },
          }),
          _vm._v(" "),
          _c("ApplyInfoButton", {
            staticClass: "ml-1",
            attrs: { "actions-text": "properties" },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mr-1" }, [
      _c("span", [_vm._v("Apply to:")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }